import React from "react";
import FadeIn from 'react-fade-in';
import Footer from "../Components/Footer";
import {Row,Container,Col} from 'react-bootstrap';
import img from "../assets/logoRecruit.png";
import { motion } from 'framer-motion';
function Join() {
  return (
    <>
    <FadeIn>
      <hr/>
      <div className="container pub-page-main">
  <div>
    {/* <h1 className="cfh">Contact Us</h1> */}
    <Container>
      <Row>
      <Col md={3}>
      <div className="reflection-container">
  <a className="reflection-grid-cell reflection-grid-cell-1" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-2" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-3" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-4" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-5" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-6" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-7" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-8" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-9" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-10" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-11" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-12" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-13" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-14" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-15" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-16" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-17" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-18" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-19" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-20" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-21" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-22" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-23" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-24" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-25" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-26" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-27" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-28" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-29" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-30" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-31" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-32" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-33" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-34" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-35" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-36" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-37" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-38" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-39" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-40" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-41" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-42" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-43" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-44" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-45" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-46" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-47" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-48" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-49" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-50" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-51" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-52" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-53" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-54" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-55" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-56" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-57" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-58" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-59" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-60" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-61" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-62" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-63" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-64" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-65" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-66" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-67" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-68" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-69" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-70" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-71" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-72" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-73" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-74" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-75" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-76" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-77" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-78" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-79" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-80" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-81" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-82" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-83" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-84" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-85" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-86" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-87" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-88" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-89" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-90" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-91" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-92" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-93" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-94" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-95" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-96" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-97" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-98" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-99" href="#" />
  <a className="reflection-grid-cell reflection-grid-cell-100" href="#" />
  <div className="reflection-content">
  <motion.img src={img} alt="risha_lab"
            className="d-block m-auto"
            style={{maxWidth:"15em",width:"100%"}}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            />
  </div>
</div>
      <p className="mt-4">
      We, at the RISHA Lab aspire to work to the best of our abilities and currently have multiple open positions for broadly in the areas of Software Engineering, Educational Technologies and Human-Computer Interaction! Have a look at RISHA Lab Open House video (2020) and Core Principles to understand who we are, what we do, what you can do! Checkout our publications and research agenda to get an idea of some of our work!
      {/* <a href="https://docs.google.com/spreadsheets/d/1K8raZO0wWKfOOHuKxoNxvQwgZABIPoXCMe6hN-Z0Zus/edit?usp=sharing" referrerPolicy="no-referrer" target="_blank">Here</a> are some broad project ideas and you can propose your own!!!  */}
      </p>
      <p>Developer Intern positions are available only for IITT students who have stellar programming skills!</p>
      {/* <form className="cf">
      <input type="button" className="button-check" defaultValue="Open Positions" onClick={(e)=>{e.preventDefault(); window.location.href='/open';}}/>
      </form> */}
      </Col>
      <Col md={9} className="my-auto">
        {/* https://theconfuzedsourcecode.wordpress.com/2019/11/11/you-may-restfully-submit-to-your-google-forms/ */}
      {/* <form className="kwes-form cf" action="https://kwes.io/api/foreign/forms/0ctNQPXDL2AlBzCTLXHU"> */}
      <Container style={{textAlign:"left"}}>
        <Row style={{fontWeight:"bold"}}>
          <Col className={"border py-2"}>Why RISHA Lab?</Col>
          <Col className={"border py-2"}>What are we looking for?</Col>
        </Row>
        <Row >
        <Col className={"border py-2"}>
        <ul style={{listStyle:"inside"}}>
        <li>Better job/research prospects by building a strong work profile! </li>
        <li>20+ publications in top-class conferences/journals such as ICSE, FSE, MSR, EASE, CSCW, CSUR and so on (last 2 years)</li>
        <li>20+ development projects/tools - Most of our projects result in tools/software </li>
        <li>The lab is in news for its work on using computing for society (The Hindu, NDTV, IndianExpress, Times of India, The Hans India, ETV, DD, The Hans,  and so on)</li>
        <li>International Research Collaborations (University of Waterloo)</li>
        <li>Industry Collaborations (Bosch, Accenture Labs…)</li>
        <li>We also have mini-projects in Educational Technologies and Human-Computer Interaction for around 4-6 months.</li>
        </ul>
        </Col>
        <Col className={"border py-2"}>
        We are always looking for enthusiastic students for Developer Interns (3 to 6 months), Research Interns (6 to 12 months), UG Research Interns (2 years - main goal is to nurture for higher studies) in addition to B.Tech projects, M.Tech projects, MS/PhD (checkout official IITT admissions channel). 
        <p>What you must have?</p>
        <ul style={{listStyle:"inside"}}>
        <li>Coding & Development </li>
        <li>Critical Thinking</li>
        <li>Quick learner</li>
        <li>Reading & Writing Papers (scientific) </li>
        <li>Formalisms (scientific perspective)</li>
        </ul>
        <p>
        <b>Note1:</b> Most of our research projects have a major software development component, application of AI/ML, NLP techniques, and any other advances required for accomplishing project goals.
        </p>
        <p>
        <b>Note2:</b> If you are not willing to do your best, move beyond your comfort zone, and are not persistent to do your best work, please do not contact us! 
        </p>


        </Col>
        </Row>
        <Row className={"py-2"}>If interested, please fill this form! 
      </Row>
      </Container>
      <form className="cf" method={"POST"} action="https://docs.google.com/forms/d/1NFyVrt7ZnGoD0oYEb8TRB2RKmwNuc0-o6iRgsXvwG-0/formResponse" >
      <div className="half left cf">
        <input type="text" id="input-name" name="entry.1129554748" placeholder="Name" />
        <input type="email" id="input-email" name="entry.1216214704" placeholder="Email address" />
        <input type="text" id="input-mob" name="entry.400633797" placeholder="Mobile Number" />
        <input type="text" id="input-ed" name="entry.410725514" placeholder="Highest level of education" />
        <input type="text" id="input-interest" name="entry.1395231050" placeholder="Interested Position / Other"/>
        <input type="text" id="input-cv" name="entry.1452408299" placeholder="Link to CV"/>
      </div>
      <div className="half right cf">
        <textarea name="message" type="text" id="input-message" rules="required" name="entry.352421593" placeholder="Why are you interested in working with RISHA Lab ?" defaultValue={""} />
        <textarea name="message" type="text" id="input-message2" rules="required" name="entry.529764944" placeholder="Please mention your past experiences in the domain of interest. Why are you qualified to work in said area ?" defaultValue={""} />
      </div> 
      <input type="submit" className="button-join" defaultValue="Submit" id="input-submit" />
    </form>
      </Col>
      </Row>
      </Container>
  </div>
  </div>
  </FadeIn>
    <Footer/>
    </>
  );
}

export default Join;
